import React from 'react';
import freshId from 'fresh-id'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'

const playTime = {
  played: false
}

const _id = freshId()

export default class ThemeVideoPlayer extends React.Component {

  componentDidMount() {
    // instantiate Video.js
    console.log('Video', 'componentDidMount', this.props)

    const {updateVideoAnalysis} = this.props
    this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
      console.log('onPlayerReady', this)
      this.on('loadedmetadata', function () {
        console.log('loadedmetadata', this.duration());
        playTime.duration = this.duration()
      });

      this.on('play', function () {
        console.log('play', this.currentTime());
        if (playTime.played) {
          if (this.currentTime() < playTime.startTime) {
            playTime.startTime = this.currentTime()
          }
        } else {
          playTime.startTime = this.currentTime()
        }
        playTime.played = true;

      });

      this.on('pause', function () {
        console.log('pause', this.currentTime());
        playTime.endTime = this.currentTime()

      });

      this.on('timeupdate', function () {
        console.log(this.currentTime(), playTime);
        playTime.endTime = this.currentTime()
      });
    });
  }

  // destroy player on unmount
  componentWillUnmount() {
    console.log('Video', 'componentWillUnmount', this.props)
    if (this.player) {
      this
        .player
        .dispose()
    }
  }


  render() {
    return (
      <div>
        <div
          data-vjs-player
          style={{
            width: '100%',
            height: '200px',
            clear: 'both',
            display: 'block'
          }}>
          <video webkit-playsinline ref={node => this.videoNode = node} className="video-js"  style={{width: '340px',height:'208px'}}/>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/theme/components/ThemeVideoPlayer.js